import { Link } from 'react-router-dom';

interface HeaderProps {
  title: string;
  index: number;
  link: string;
  headingClassName?: string;
}

const OnboardingHeaderWrapper = ({
  title,
  index,
  link,
  headingClassName = '',
}: HeaderProps) => {
  const defaultStep = [
    <div className="w-6 h-2 bg-lightBlue bg-opacity-20 rounded-[22px]" />,
    <div className="w-6 h-2 bg-lightBlue bg-opacity-20 rounded-[22px]" />,
    <div className="w-6 h-2 bg-lightBlue bg-opacity-20 rounded-[22px]" />,
  ];
  return (
    <>
      <div
        className="flex justify-between items-center md:mb-11"
        key={`${title}-${index}`}
      >
        <div className="flex gap-1">
          {defaultStep?.map((step, i) => {
            if (i === index) {
              step = (
                <div key={i} className="w-14 h-2 bg-lightBlue rounded-[22px]" />
              );
            }
            return step;
          })}
        </div>
        <div>
          <p className="text-center text-lightBlue hover:text-darkBlue text-base font-bold font-SFProDisplay">
            {link === 'Create Account' ? (
              <Link to="/register">{link}</Link>
            ) : (
              <Link to="/login">{link}</Link>
            )}
          </p>
        </div>
      </div>
      <h1
        className={`text-blue-950 text-[40px] font-bold font-SFProDisplay tracking-normal my-10 leading-[48px] ${headingClassName}`}
      >
        {title}
      </h1>
    </>
  );
};

export default OnboardingHeaderWrapper;
